module.exports = __webpack_public_path__ + "img/balkon11.65cec77f.webp";